export default "__VITE_ASSET__Lr0GVeyQ__"